/* eslint-disable indent */
import getPromiseTypes from '../../../helpers/getPromiseTypes';
import { PROMISE_TYPE_SUFFIXES } from '../../actions/types';

const [P, F, R] = PROMISE_TYPE_SUFFIXES;

export default function ReducerWithNamedType(NAMED_TYPE, data = []) {
  const [PENDING, FULLFILLED, REJECTED] = getPromiseTypes(NAMED_TYPE);
  return function reducer(
    state = {
      status: P,
      data
    },
    action
  ) {
    switch (action.type) {
      case PENDING:
        return { ...state, status: P };
      case REJECTED:
        return { ...state, data: action.payload, status: R };
      case FULLFILLED:
        return {
          ...state,
          status: F,
          data: action.payload
        };
      default:
        return state;
    }
  };
}
